<!--
 * @Author: 俊昌 junchang.zhang@wahool.com
 * @Date: 2024-01-22 17:06:27
 * @LastEditors: 俊昌 junchang.zhang@wahool.com
 * @LastEditTime: 2024-01-25 12:16:23
 * @FilePath: /flowBusinessui/src/components/sider_/SubMenu.vue
 * @Description: 
 * 
 * Copyright (c) 2024 by ${git_name_email}, All Rights Reserved. 
-->
<template>
  <a-sub-menu :key="`${path}`" v-bind="$props">
    <template #title>
      <p class="flexL">
        <span v-if="menuInfo.meta.icon" class="anticon"><i :class="menuInfo.meta.icon"></i></span>
        <span style="height: 15px; line-height: 15px">{{ t(`route.${name}.${name}`) }}</span>
      </p>
    </template>
    <template v-for="item in menuInfo.children">
      <a-menu-item class="flexL" style="display: flex" v-if="!item.children && item.hidden" :key="`${path}/${item.path}`" @click="$router.push(`${path}/${item.path}`)">
        <p class="flexL" style="display: flex">
          <span v-if="item.meta.icon" class="anticon"><i :class="item.meta.icon"></i></span>
          <span style="height: 15px; line-height: 15px">{{ t(`route.${name}.${item.name}`) }}</span>
          <!-- 亚马逊绑定快过期时或已过期时展示小红点提示 -->
          <!-- <div v-if="item.path === 'Amazon' && ($store?.getters?.AmazonInfo?.refreshTokenExpireState === 'ABOUT_TO_EXPIRE' || $store?.getters?.AmazonInfo?.refreshTokenExpireState === 'EXPIRED')" class="tips-box">
            <img src="@/assets/images/amazon_tips_icon.png" alt="tips"/>
          </div> -->
        </p>
      </a-menu-item>
      <sub-menu
        v-if="item.children && item.hidden"
        :name="`${name}.${item.name}`"
        :path="`${path}/${item.path}`"
        :key="item.path"
        :data="menuInfo"
        :menu-info="item"
        :collapsed="collapsed"
      />
    </template>
  </a-sub-menu>
</template>

<script>
  import { useI18n } from 'vue-i18n'

  export default {
    name: 'SubMenu',
    props: {
      menuInfo: Object,
      collapsed: Boolean,
      name: String,
      path: String,
      data: {
        type: Object,
        default: null
      }
    },
    setup() {
      const { t } = useI18n()
      return {
        t
      }
    }
  }
</script>

<style scoped lang="less">
  p {
    padding: 0px;
    margin: 0;
  }

  .anticon {
    i {
      font-size: 14px;
      width: 14px;
      height: 14px;
    }
  }
  .tips-box {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background: #fb5d43;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    right: 12px;
    img {
      width: 13px;
      height: 13px;
    }
  }
</style>
